import { render } from "./SimpleNoteDetail.vue?vue&type=template&id=550a8895&scoped=true"
import script from "./SimpleNoteDetail.vue?vue&type=script&lang=js"
export * from "./SimpleNoteDetail.vue?vue&type=script&lang=js"

import "./SimpleNoteDetail.vue?vue&type=style&index=0&id=550a8895&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-550a8895"]])

export default __exports__